import { render, staticRenderFns } from "./RecipeTable.vue?vue&type=template&id=abc3be78&scoped=true"
import script from "./RecipeTable.vue?vue&type=script&lang=js"
export * from "./RecipeTable.vue?vue&type=script&lang=js"
import style0 from "./RecipeTable.vue?vue&type=style&index=0&id=abc3be78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc3be78",
  null
  
)

export default component.exports